
// Definición de defaults

export const defaultTipoSesion: TipoSesionProps = {
    idTipoSesion:  0,
    descripcion:    '',
    activo:         false,
};

// Creación de interfaces

export interface TipoSesionProps{
    idTipoSesion:  number;
    descripcion:    string;
    activo:         boolean;
}
